import { Fragment } from 'react'

import { getSplitRegex, isMatchIndex } from '../../utils/searchText'

import * as styles from './HighlightedSearchText.module.css'

function HighlightedSearchText({
  className = styles.HighlightedSearchText,
  query,
  text,
}) {
  if (!text || !query?.trim()) {
    return <>{text}</>
  }

  const regex = getSplitRegex(query)

  if (!regex) {
    return <>{text}</>
  }

  const parts = text.split(regex)

  return (
    <>
      {parts.map((part, index) =>
        isMatchIndex(index) ? (
          <span className={className} key={index}>
            {part}
          </span>
        ) : (
          <Fragment key={index}>{part}</Fragment>
        )
      )}
    </>
  )
}

export default HighlightedSearchText
